var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16008 2.18082L1.6276 1.45728C1.81182 1.17219 2.12808 1 2.46752 1H5.53248C5.87192 1 6.18818 1.17219 6.3724 1.45728L6.83992 2.18082C6.94441 2.34254 7 2.53099 7 2.72354V9.64253C7 9.90234 6.89889 10.1519 6.71807 10.3385L6.37159 10.696C6.18324 10.8903 5.92416 11 5.65353 11H2.34647C2.07584 11 1.81676 10.8903 1.6284 10.696L1.28193 10.3385C1.10111 10.1519 1 9.90234 1 9.64253V2.72354C1 2.53099 1.05559 2.34254 1.16008 2.18082Z",
    stroke: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3L7 3",
    stroke: "#4F4F4F",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9L7 9",
    stroke: "#4F4F4F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetal);
export default __webpack_public_path__ + "static/media/Metal.bd138d180b68d7590013518d1f18a3eb.svg";
export { ForwardRef as ReactComponent };